export default {
  detail_fuzhi:function(item){
    return JSON.parse(JSON.stringify(item))
  },
  baifenbi:function(a,b){
    if(b==0){
        return '0.00%'
    }else{
        return ((parseFloat(a/b))*100).toFixed(2) + '%'
    }
  }
}




// WEBPACK FOOTER //
// ./src/common/index.js